import { isFieldEqual } from "@bps/fluent-ui";

export const isEqualMfa = (prevValue: unknown, value: unknown) => {
  if (Array.isArray(prevValue) && Array.isArray(value)) {
    if (prevValue.length !== value.length) return false;
    // Check if all values in prevValue are included in value in the same order
    return prevValue.every((v, idx) => {
      return value.includes(v) && idx === value.indexOf(v);
    });
  }
  return isFieldEqual(prevValue, value);
};
